import { Component, OnInit } from '@angular/core';
import { MaterialModule } from '@shared/modules/material/material.module';
import { CommonModule } from '@angular/common';
import { GraphqlService } from '@core/services/graphql/graphql.service';
import {
  FooterApiResponse,
  FooterBlock,
  TransformedFooterBlock,
} from '@app/shared/types/footer.types';
import { ApolloQueryResult } from '@apollo/client/core';
import { RichTextComponent } from '../../rich-text/rich-text.component';

@Component({
  selector: 'rsc-asp-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'], // Corrected from 'styleUrl' to 'styleUrls' for consistency
  standalone: true,
  imports: [MaterialModule, CommonModule, RichTextComponent],
})
export class FooterComponent implements OnInit {
  footerData: TransformedFooterBlock | null = null;

  constructor(private graphqlService: GraphqlService) {}

  ngOnInit(): void {
    this.fetchFooterData();
  }

  private fetchFooterData(): void {
    const footerBlockId = 'footerBlock';
    this.graphqlService.getFooterBlockData(footerBlockId).subscribe({
      next: (result: ApolloQueryResult<FooterApiResponse>) => {
        if (result.data.footerBlockCollection.items?.length) {
          this.footerData = this.transformFooterData(
            result.data.footerBlockCollection.items[0],
          );
        }
      },
      error: (error) => {
        console.error('Error fetching footer block data:', error);
      },
    });
  }

  private transformFooterData(apiData: FooterBlock): TransformedFooterBlock {
    return {
      partneshipTitle: apiData.partneshipTitle || '',
      navigationLinksTitle: apiData.navigationLinksTitle || '',
      navigationLinks: apiData.navigationLinksCollection?.items || [],
      socialMediaLinksTitle: apiData.socialMediaLinksTitle || '',
      socialMediaLinks:
        apiData.socialMediaLinksCollection?.items.map((item) => ({
          platformName: item.platformName,
          link: item.link,
          icon: item.icon?.url,
        })) || [],
      fundersAndSupportersTitle: apiData.fundersAndSupportersTitle || '',
      fundersAndSupportersSubTitle: apiData.fundersAndSupportersSubTitle || '',
      fundersSupportersLogos:
        apiData.fundersSupportersLogosCollection?.items.map((item) => ({
          altText: item.altText,
          image: item.image?.url,
        })) || [],
      partnershipLogos:
        apiData.partnershipLogosCollection?.items.map((item) => ({
          altText: item.altText,
          image: item.image?.url,
        })) || [],
      fundersAndSupportersBody: apiData.fundersAndSupportersBody || null,
      copyrightInformation: apiData.copyrightInformation || null,
      bottomLogo: apiData.bottomLogo || null,
    };
  }
}
